import { render, staticRenderFns } from "./InterestInfo.vue?vue&type=template&id=fbba1c22"
import script from "./InterestInfo.vue?vue&type=script&lang=ts"
export * from "./InterestInfo.vue?vue&type=script&lang=ts"
import style0 from "./InterestInfo.vue?vue&type=style&index=0&id=fbba1c22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports